import React from "react"; 
import { Loading, ActionBar, BoxArea } from "../component/BaseComponent";
import MenuComp, { PageTitle } from "../component/menucomp";
import { FormGroup } from '../component/form';

// import Pagination from "../component/Paginator"
// import { FaEdit } from "react-icons/fa";
import { HttpsRequest, GetAuth, Alerts } from '../component/Utils';
import { APIRoute, RespStatus } from "../component/texts";
import { ReactSearchAutocomplete as AutoComplete } from 'react-search-autocomplete'; 


type PriceType = {
    body: Record<string, string|number>;
    isbusy: boolean;
    view_mode: boolean;
    form: Record<string, any>[];
    data: Record<string, number | string | unknown| any>;
    is_search: boolean;
	search_data: Record<string, any>[];
	search: string;
}



const URL = "https://maps.googleapis.com/maps/api/place/autocomplete/json?"
const PLACEIDURL = "https://maps.googleapis.com/maps/api/place/details/json?"
const ReverseLookup = "https://maps.googleapis.com/maps/api/geocode/json?"
const HEADERS = { 'Content-Type': 'application/json'}


const GoogleSearchHttp = (
  url: string,
  success_cb: (resp: Record<string, unknown>) => void,
  failed_cb: (resp: string) => void
) => {

  fetch(url, { method: "GET", headers: HEADERS })
    .then(res => {
      if (res.status > 399)
        return {
          error: `application error with status code ${res.status}`,
          status: -1,
        };
      else {
        return res.json();
      }
    })
    .then((resp) => {
      if (resp.error!) {
        failed_cb(resp.error)
      } else {
        success_cb(resp)
      }
    })
    .catch(failed_cb);

}

export default class PriceEstimateUI extends React.Component<IProps, PriceType> {


    constructor(props: IProps){

        super(props); 

        this.state = {
            body: {},
            isbusy: false,  
            form: [],
            data: {},
            view_mode: false,
            is_search: false,
            search_data: [],
            search: ''
        }

    }

    render (){
 
          
        let sidecls = "col-md-6 col-sm-12";

        return (
            <div>
                <MenuComp />
                <br />
                <br />
                <ActionBar
                    classname={sidecls}
                    placeholder={"search"}
                    search={false}                    
                />

                <br/>
                <br/>

                <div className="container-fluid">
                    <div className="row posrel">

                        <BoxArea classname={sidecls + ' posrel'} >
                            <PageTitle title={'Price Estimation'} />
 							
 							<div className='mbt5'> 
 								<p className='alert alert-warning text-center'>
 									
 									For best results when searching use street names, popular land marks or nearest bustops <br/> 
 									for both the dispatch and destination address.

 								</p> 
 							</div>
 							<div>			 							
                              	{
                                this.state.form.map((fld, idx) => {
                                    return <FormGroup
                                        key={`device-${idx}`}
                                        obj={fld}
                                        onchange={
                                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                            this.onchange(e);
                                        }}
                                        onselectchange={this.onchange}                            
                                    />;
                                })
                            	}

	                            <div className={this.state.search === 'dispatch'? "mb-4 mt-4 posrel z1000" : 'mb-4 mt-4'}>
                            		<label htmlFor="dispatch_loc"> Dispatch Address </label>

                            		<AutoComplete                             			
                            			onSearch={this.trigger_search}
                            			onFocus={()=> this.setState({search: 'dispatch'})}                            			
                            			placeholder={'enter dispatch address'} 
                            			items={this.state.search_data} 
                            			formatResult={this.format_result}
                            			onSelect={this.handle_select}

                            		/>

	                            </div>

	                            <div className= {this.state.search === 'destination'? "mb-4 mt-4 posrel z1000" : 'mb-4 mt-4'}>
                            		<label htmlFor="delivery_loc"> Delivery Address </label>

                            		<AutoComplete 
                            			
                            			placeholder={'enter delivery address'}
                            			onFocus={()=> this.setState({search: 'destination'})}
                            			items={this.state.search_data} 
                            			formatResult={this.format_result}
                            			onSelect={this.handle_select}
                            			onSearch={this.trigger_search}
                            		/>

                            	</div>
	                            <div className="mb-4 mt-4">
	                                <div className="form-group row">
	                                    <div className="row">
	                                        <div className="d-grid gap-2 col-md-6 col-sm-12 mb-3">
	                                            <button type="button" onClick={this.swap_view} className="btn btn-primary btn-lg">
	                                                Calculate Price
	                                            </button>
	                                        </div>                                     
	                                    </div>
	                                </div>

	                            </div>
                         
                           		{this.state.isbusy && <Loading />}
                              
                            </div>
                            <div id='maparea'></div>
                        </BoxArea>

                        {
                            this.state.view_mode ? (
                                <BoxArea classname={'col-md-6'} >
                                    
                                    <div>
                                    	
                                    	<img id='image_box' className='imgbox'/>

                                    	<div className='d-flex flex-col mt-4 bg-grey justify-content-center'>                                    		
                                    		<p className={'p-4'}> Estimated Distance:  <span className='bold'> {this.state.data.distance} </span> </p>
                                    		<p className={'p-4'}> Price Range: <span className='bold'> {this.state.data.price_range } </span> </p>
                                    	</div>

                                    </div>	 
                                </BoxArea>


                            ) : null
                        }
                        
                    </div>

                </div>

                <style>
                	{`
                	.wrapper:first-child {
                		border-radius: 5px;
                	}
                	.z1000{ z-index: 1000; }
                	.imgbox{
                		width: 100%;
                		height: 500px;
                		border-radius: 5px;

                	}
                	#maparea{
                		width: 1px;
                		height: 1px;
                	}
                	.bg-grey {

                		background-color: #eeeeee;
                	}
            	`}
                </style>
            </div>

        )
       
    }

    format_result = (item:Record<string, any>) => {
    	return (
    		<span>{item.name}</span>
    	)
    }

    handle_select = (item:Record<string, any>) => {
 
		this.setState({
			data:{ ...this.state.data, [this.state.search]: {...item.geometry.location, address: item.name }}
		})
  
    }

    trigger_search = (inputval:string, results?:Record<string, any>[]) => {
 

    	if (inputval.length >= 3){
    		this.google_address_search(inputval)
    	}

    }

    get_default_formdata = (form: Record<string, any>[], field: string) => {

    	let row = form.find(item => item.name == field )

    	if (row !== undefined){
    		return row['defaultvalue']
    	}

    	return undefined
    }


    get_place_coods = (place_id: string, fieldname:string) => {

	    this.setState({ isbusy: true });

	    const success_func = (resp: Record<string, any>) => {

	      if (resp.status === "OK") {
	        this.setState(
	          {data: { ...this.state.data, [fieldname]: resp.result.geometry.location }}
	        )
	      } else {
	      	Alerts.show_error(resp.status);
	      }
	    }

	    const failed_func = (resp: string) => {
	      this.setState({ isbusy: false })
	      Alerts.show_error(resp)
	    }

	    const params = new URLSearchParams({
	      key: this.state.body['google_key'] as string,
	      place_id: place_id
	    }).toString();

	    GoogleSearchHttp(PLACEIDURL + params, success_func, failed_func);

	}
	
	google_address_search = (input: string) => {

	    const failed_callback = (err: string) => {
	      this.setState({ is_search: false })
	      Alerts.show_error(err || "Application error has occurred!");
	    }

	    const params = new URLSearchParams({
	      key: this.state.body['google_key'] as string,
	      input: input
	    }).toString();

	    const success_cb = (results: google.maps.places.PlaceResult[] | null,
      		status: google.maps.places.PlacesServiceStatus
		) => {
  
	      if (status === 'OK' && results ) {
	        this.setState({ search_data: results, is_search: false })
	      } else {
	        this.setState({ search_data: [], is_search: false }); // to see if it drops empty shell 
	        Alerts.show_error(status)
	      }

	    }

	    this.setState({is_search: true});
	    

	    let map = new google.maps.Map(document.getElementById("maparea") as HTMLElement);
	    
	    let request = {
	    	query: input,
	    	"fields": ['name', 'geometry']
	    }

	    const service = new google.maps.places.PlacesService(map);
	    service.findPlaceFromQuery(request, success_cb)

	}



    init_data = ()=> {

    	const get_callback = (resp: RespArgs) => {
        	
        	console.log(resp);

	        if (resp.status == RespStatus.success){
	            this.setState({
	                body: resp.body, 
	                isbusy: false, 	   
	                form: resp.body.form, 
	                // reset form every upload
	                
	            });

	        } else {
	            this.setState({
	                isbusy: false 
	            })
	            
	            Alerts.show_error(resp.status_msg); 

	        }
	 
	    }


    	HttpsRequest.get(
            APIRoute.price_estimate, 
            get_callback,  
            GetAuth(), 
            {}, 
            (r:RespArgs) => this.setState({isbusy: false})
        )

        this.setState({isbusy: true, form: []})

    }


    componentDidMount(): void {
        this.init_data() 
    }

    onchange = (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => {
 
        const {data} = this.state ; 

        data[event.target.name] = event.target.value; 

        this.setState({
            data
        })
    }

    swap_view = () => {
		   
		if (this.state.data.dispatch && this.state.data.destination){

			var disp_lat = this.state.data.dispatch?.lat(); //  dispatch_latlng['lat'];
			var disp_lng = this.state.data.dispatch?.lng();  //  dispatch_latlng['lng'];

			var dest_lat = this.state.data.destination.lat();
			var dest_lng = this.state.data.destination.lng();


			let google_key = this.state.body['google_key'];

			let str_loc = `https://maps.googleapis.com/maps/api/staticmap?path=color:0x0000b3|weight:5|${disp_lat},${disp_lng}|${dest_lat},${dest_lng}&center=${disp_lat},${disp_lng}&zoom=10&size=900x600&scale=1&maptype=roadmap&markers=color:yellow|${disp_lat},${disp_lng}&markers=color:green|${dest_lat},${dest_lng}&key=${google_key}`;


			var directionsService = new google.maps.DirectionsService();
			var directionsDisplay = new google.maps.DirectionsRenderer();
			var request = {
		       origin: `${disp_lat},${disp_lng}`, 
		       destination: `${dest_lat},${dest_lng}`,
		       travelMode: google.maps.TravelMode.DRIVING
		   };

		   var distance_btw_dt;

		   	directionsService.route(request, (resp:any, status:any) => {

		   		if (status === 'OK'){
		   			 
		   			if ( resp !== undefined || resp !== null && resp.routes){
		   				
		   				distance_btw_dt = resp.routes[0].legs[0].distance.text || '0km';

		   				let dis_meters = resp.routes[0].legs[0].distance.value  || 0;  
		   				let price_range = this.price_estimation((dis_meters / 1000) )

		   				this.setState({
							data: {
								...this.state.data, 
								price_range: price_range,
								distance: distance_btw_dt
							},
							view_mode: true
						}, () => {
							let img: any = document.getElementById('image_box');
							if (img) img.src = str_loc;
						});

		   			}

		 		} else {
		 			Alerts.show_error('address mismatch detacted!!!');
		 		}

		   	})
  
			 
		} else if ( !this.state.data.dispatch  ){
			Alerts.show_error('Dispatch Address field required!');
		} else if (  !this.state.data.destination ) {
			Alerts.show_error('Destination Address field required!'); 
		}
		

	}

	calcCrow = (lat1:number, lon1:number, lat2:number, lon2:number) => {
      	var R = 6371; // km
      	var dLat = this.toRad(lat2-lat1);
      	var dLon = this.toRad(lon2-lon1);
      	var lat1 = this.toRad(lat1);
      	var lat2 = this.toRad(lat2);

      	var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2); 
      	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      	var d = R * c;
      	return d;
    }


    // Converts numeric degrees to radians
    toRad = (value: number) => {
        return value * Math.PI / 180;
    }
 

	price_estimation = (distance_km:number) => {


		// bench mark for a 10 km drive  
		// min price is based on 10km and below 

		let default_price = this.get_default_formdata(this.state.form, 'price')
		let min_price = Number(
			this.format_amount(default_price)
		);

		let min_km = Number(this.state.body.min_km);
		let extra_km, base_price, extra_price;

		if (distance_km <= min_km) {
			return `NGN ${min_price.toLocaleString()}`;
		}

		else if (distance_km > min_km ) {

			extra_km = distance_km % min_km; // remainder 
			base_price = ((distance_km - extra_km ) / min_km ) * min_price ; 
	 		extra_price = base_price + ((extra_km / min_km) * min_price) ; 
		}

		return `between  NGN ${base_price?.toLocaleString()}  and  NGN ${extra_price?.toLocaleString()}` ;

	}


	format_amount = (val: string) => {

		val = this.remove_spaces(val);

		let amt_list = val.split(',') ; 

		let amt = '';

		for (var x=0; x < amt_list.length;  x++){
			amt = amt + amt_list[x]
		}  
		return amt;
	}

	remove_spaces = (val:string) => {

		let amt_list = val.split(' ');
		let amt = "";
		
		for (var x=0; x < amt_list.length;  x++){
			amt = amt + amt_list[x];
		}

		return amt ;
	}

}
